import { StyleParamType } from '@wix/tpa-settings';
import {
  MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  MOBILE_GRID_DEFAULT_COUNT_ITEM_IN_ROW,
  DESK_GRID_DEFAULT_COUNT_ITEM_IN_ROW_HASHTAG,
  MOBILE_DEFAULT_COUNT_ROWS,
  MOBILE_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW,
} from '../constants/proGalleryConstants';
import {
  M_PROFILE_LAYOUT_POSITIN,
  M_FEED_LAYOUT_POSITIN,
  M_HASHTAG_LAYOUT_POSITIN,
  DEFAULT_AVATAR_SIZE_MOBILE,
  DEFAULT_AVATAR_PADDING_LEFT_RIGHT_MOBILE,
  DEFAULT_AVATAR_PADDING_TOP_BOTTOM_MOBILE,
} from '../constants';
import {
  LAYOUTS,
  MOBILE_BIO_DISPLAY_OPTIONS,
  COLLAGE_POST_SIZE,
} from '../constants/settingsConstants';

const instagramStyleParams = {
  /// //////////////////////
  // BOOLEANS
  /// //////////////////////
  m_isDisplayProfileInfo: {
    type: StyleParamType.Boolean,
    key: 'm_isDisplayProfileInfo',
    getDefaultValue: () => true,
  },
  m_isDisplayProfilePicture: {
    type: StyleParamType.Boolean,
    key: 'm_isDisplayProfilePicture',
    getDefaultValue: () => true,
  },
  m_isDisplayTitle: {
    type: StyleParamType.Boolean,
    key: 'm_isDisplayTitle',
    getDefaultValue: () => true,
  },
  m_isDisplayTitlesHashtag: {
    type: StyleParamType.Boolean,
    key: 'm_isDisplayTitlesHashtag',
    getDefaultValue: () => true,
  },
  m_isDisplayPostsCount: {
    type: StyleParamType.Boolean,
    key: 'm_isDisplayPostsCount',
    getDefaultValue: () => true,
  },
  m_isDisplayFollowersCount: {
    type: StyleParamType.Boolean,
    key: 'm_isDisplayFollowersCount',
    getDefaultValue: () => true,
  },
  m_isDisplayFollowingCount: {
    type: StyleParamType.Boolean,
    key: 'm_isDisplayFollowingCount',
    getDefaultValue: () => true,
  },
  m_isDisplayFollowBtn: {
    type: StyleParamType.Boolean,
    key: 'm_isDisplayFollowBtn',
    getDefaultValue: () => true,
  },
  m_isDisplayImagesFeed: {
    type: StyleParamType.Boolean,
    key: 'm_isDisplayImagesFeed',
    getDefaultValue: () => true,
  },
  m_isDisplayHashtagsFeed: {
    type: StyleParamType.Boolean,
    key: 'm_isDisplayHashtagsFeed',
    getDefaultValue: () => true,
  },
  m_isShowMoreBtn: {
    type: StyleParamType.Boolean,
    key: 'm_isShowMoreBtn',
    getDefaultValue: () => true,
  },
  m_isShowMoreBtnHashtag: {
    type: StyleParamType.Boolean,
    key: 'm_isShowMoreBtnHashtag',
    getDefaultValue: () => true,
  },
  m_isShowMoreBtnCollageHashtag: {
    type: StyleParamType.Boolean,
    key: 'm_isShowMoreBtnCollageHashtag',
    getDefaultValue: () => true,
  },
  m_isShowMoreBtnCollage: {
    type: StyleParamType.Boolean,
    key: 'm_isShowMoreBtnCollage',
    getDefaultValue: () => true,
  },
  /// //////////////////////
  // NUMBERS
  /// //////////////////////
  m_headerLayout: {
    type: StyleParamType.Number,
    key: 'm_headerLayout',
    getDefaultValue: () => 0,
  },
  m_galleryLayout: {
    type: StyleParamType.Number,
    key: 'm_galleryLayout',
    getDefaultValue: () => LAYOUTS.GRID,
  },
  m_galleryLayoutHashtag: {
    type: StyleParamType.Number,
    key: 'm_galleryLayoutHashtag',
    getDefaultValue: () => LAYOUTS.SLIDER,
  },
  m_numberOfRowsGrid: {
    type: StyleParamType.Number,
    key: 'm_numberOfRowsGrid',
    getDefaultValue: () => MOBILE_DEFAULT_COUNT_ROWS,
  },
  m_numberOfRowsGridHashtag: {
    type: StyleParamType.Number,
    key: 'm_numberOfRowsGridHashtag',
    getDefaultValue: () => MOBILE_DEFAULT_COUNT_ROWS,
  },
  m_numberOfColumnsGrid: {
    type: StyleParamType.Number,
    key: 'm_numberOfColumnsGrid',
    getDefaultValue: () => MOBILE_GRID_DEFAULT_COUNT_ITEM_IN_ROW,
  },
  m_numberOfColumnsGridHashtag: {
    type: StyleParamType.Number,
    key: 'm_numberOfColumnsGridHashtag',
    getDefaultValue: () => DESK_GRID_DEFAULT_COUNT_ITEM_IN_ROW_HASHTAG,
  },
  m_spacingItemsGrid: {
    type: StyleParamType.Number,
    key: 'm_spacingItemsGrid',
    getDefaultValue: () => MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  m_gallerySpacingGrid: {
    type: StyleParamType.Number,
    key: 'm_gallerySpacingGrid',
    getDefaultValue: () => MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  m_gallerySpacingGridHashtag: {
    type: StyleParamType.Number,
    key: 'm_gallerySpacingGridHashtag',
    getDefaultValue: () => MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  m_gallerySpacingCollage: {
    type: StyleParamType.Number,
    key: 'm_gallerySpacingCollage',
    getDefaultValue: () => MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  m_gallerySpacingCollageHashtag: {
    type: StyleParamType.Number,
    key: 'm_gallerySpacingCollageHashtag',
    getDefaultValue: () => MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  m_gallerySpacingSlider: {
    type: StyleParamType.Number,
    key: 'm_gallerySpacingSlider',
    getDefaultValue: () => MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  m_gallerySpacingSliderHashtag: {
    type: StyleParamType.Number,
    key: 'm_gallerySpacingSliderHashtag',
    getDefaultValue: () => MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  m_spacingItemsGridHashtag: {
    type: StyleParamType.Number,
    key: 'm_spacingItemsGridHashtag',
    getDefaultValue: () => MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  m_numberOfColumnsSlider: {
    type: StyleParamType.Number,
    key: 'm_numberOfColumnsSlider',
    getDefaultValue: () => MOBILE_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW,
  },
  m_numberOfColumnsSliderHashtag: {
    type: StyleParamType.Number,
    key: 'm_numberOfColumnsSliderHashtag',
    getDefaultValue: () => MOBILE_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW,
  },
  m_spacingItemsSlider: {
    type: StyleParamType.Number,
    key: 'm_spacingItemsSlider',
    getDefaultValue: () => MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  m_spacingItemsSliderHashtag: {
    type: StyleParamType.Number,
    key: 'm_spacingItemsSliderHashtag',
    getDefaultValue: () => MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  m_profilePictureRadius: {
    type: StyleParamType.Number,
    key: 'm_profilePictureRadius',
    getDefaultValue: () => DEFAULT_AVATAR_SIZE_MOBILE,
  },
  m_profilePicturePaddingVer: {
    type: StyleParamType.Number,
    key: 'm_profilePicturePaddingVer',
    getDefaultValue: () => DEFAULT_AVATAR_PADDING_TOP_BOTTOM_MOBILE,
  },
  m_profilePicturePaddingHor: {
    type: StyleParamType.Number,
    key: 'm_profilePicturePaddingHor',
    getDefaultValue: () => DEFAULT_AVATAR_PADDING_LEFT_RIGHT_MOBILE,
  },
  m_avatarFontSize: {
    type: StyleParamType.Number,
    key: 'm_avatarFontSize',
    getDefaultValue: () => DEFAULT_AVATAR_SIZE_MOBILE / 2,
  },
  m_userNameTextSize: {
    type: StyleParamType.Number,
    key: 'm_userNameTextSize',
    getDefaultValue: () => 20,
  },
  m_countersTextSize: {
    type: StyleParamType.Number,
    key: 'm_countersTextSize',
    getDefaultValue: () => 14,
  },
  m_bioTextSize: {
    type: StyleParamType.Number,
    key: 'm_bioTextSize',
    getDefaultValue: () => 14,
  },
  mobileShowMoreFontSize: {
    type: StyleParamType.Number,
    key: 'mobileShowMoreFontSize',
    getDefaultValue: () => 14,
  },
  mobileShowMoreBorderWidth: {
    type: StyleParamType.Number,
    key: 'mobileShowMoreBorderWidth',
    getDefaultValue: () => 1,
  },
  m_btnCornerRadius: {
    type: StyleParamType.Number,
    key: 'm_btnCornerRadius',
    getDefaultValue: () => 0,
  },
  [M_PROFILE_LAYOUT_POSITIN]: {
    type: StyleParamType.Number,
    key: M_PROFILE_LAYOUT_POSITIN,
    getDefaultValue: () => 0,
  },
  [M_FEED_LAYOUT_POSITIN]: {
    type: StyleParamType.Number,
    key: M_FEED_LAYOUT_POSITIN,
    getDefaultValue: () => 1,
  },
  [M_HASHTAG_LAYOUT_POSITIN]: {
    type: StyleParamType.Number,
    key: M_HASHTAG_LAYOUT_POSITIN,
    getDefaultValue: () => 2,
  },
  m_displayBio: {
    type: StyleParamType.Number,
    key: 'm_displayBio',
    getDefaultValue: () => MOBILE_BIO_DISPLAY_OPTIONS.SEE_MORE_BTN,
  },
  m_collagePostSizeHashtag: {
    type: StyleParamType.Number,
    key: 'm_collagePostSizeHashtag',
    getDefaultValue: () => COLLAGE_POST_SIZE.LARGE,
  },
  m_collagePostSize: {
    type: StyleParamType.Number,
    key: 'm_collagePostSize',
    getDefaultValue: () => COLLAGE_POST_SIZE.LARGE,
  },
  m_spacingItemsCollage: {
    type: StyleParamType.Number,
    key: 'm_spacingItemsCollage',
    getDefaultValue: () => MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  m_spacingItemsCollageHashtag: {
    type: StyleParamType.Number,
    key: 'm_spacingItemsCollageHashtag',
    getDefaultValue: () => MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  m_rowsLoadMoreCollageHashtag: {
    type: StyleParamType.Number,
    key: 'm_rowsLoadMoreCollageHashtag',
    getDefaultValue: () => 1,
  },
  m_rowsLoadMoreCollage: {
    type: StyleParamType.Number,
    key: 'm_rowsLoadMoreCollage',
    getDefaultValue: () => 1,
  },
  /// //////////////////////
  // COLORS
  /// //////////////////////

  /// //////////////////////
  // FONTS
  /// //////////////////////
};

export default instagramStyleParams;
